import React from 'react';
import { createForm } from 'rc-form';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import get from 'lodash/get';
import map from 'lodash/map';
import forEach from 'lodash/forEach';
import find from 'lodash/find';

import axios from 'utils/axios';
import Text from 'ui/Text';
import Button from 'ui/Button';
import FieldProcessor from 'components/BaseQuestionnaire/FieldProcessor';
import Auth from 'shared/Auth';
import { SavingSubject } from 'shared/SavingSubject';
import { FileSaveSubject } from 'shared/FileSaveSubject';
import { ControlPassSubject } from 'shared/ControlPassSubject';
import { QuestionnaireSubject } from 'shared/QuestionnaireSubject';
import localStorage from 'utils/localStorage';
import { QUESTIONS_KEY, PREVIOUS_STAGE_KEY } from 'utils/app-constants';
import { CDRComponentMap } from '../CDRSections/CDRComponentMap';
import PageNotFound from 'shared/PageNotFound';

let fileItem = '';
let processQue = [];
let timeout;
let selectedFields;
let activeControlType;

class FormLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      questions: this.props.questions || [],
      saving: false,
      statusMessage: 'Saving...',
      errorMessage: '',
      cdrScores: [],
      newRowValue: 5,
      surveyMode: Auth.isSurveyMode(),
    };

    this.subscription = null;
    this.savingSubjectListener = null;
    this.fileSaveListener = null;
    this.controlPassListener = null;
  }

  componentDidMount() {
    this.savingSubjectListener = SavingSubject.subscribe((newState) => {
      this.setState({ ...newState });
    });

    this.fileSaveListener = FileSaveSubject.subscribe((file) => {
      fileItem = file;
    });

    this.controlPassListener = ControlPassSubject.subscribe((controlPass) => {
      activeControlType = get(controlPass, 'controlType');
      
      selectedFields = get(controlPass, 'field');
    });
  }

  componentWillReceiveProps(newProps) {
    const newQuestions = newProps.questions;

    this.updateQuestions(newQuestions);
  }

  componentWillUnmount() {
    if (this.savingSubjectListener !== null) {
      this.savingSubjectListener.unsubscribe();
      this.savingSubjectListener = null;
    }

    if (this.fileSaveListener !== null) {
      this.fileSaveListener.unsubscribe();
      this.fileSaveListener = null;
    }
  }

  saveAndContinue = () => {
    this.props.history.push('/login');
    Auth.logout();
  };

  updateQuestions = (questions) => {
    this.setState({ questions });
  };

  goToNextpage = () => {
    this.props.history.push(`/section/${this.props.nextSectionId}`);
  };

  addRow = (tableRows) => {
    this.setState({
      newRowValue: ++tableRows
    });
  }  

  completeApplication = () => {
    let payload = {
      user_id: get(Auth.getUser(), 'id'),
      dry_run: false
    };

    this.setState({errorMessage: ''});

    SavingSubject.next({
      saving: true,
      statusMessage: 'Completing the application...',
    });

    axios
      .post(`/stage/${get(Auth.getUser(), 'current_stage_id')}/complete`, payload)
      .then(response => {
        SavingSubject.next({ saving: false });

        let isError = get(response.data, 'status.status');
        
        if (isError === 'fail') {
          this.setState({ errorMessage: get(response.data, 'status.message', "You have successfully completed your application for stage II of the African CSO Excellence Awards.We will announce the 27 shortlisted CSOs in mid-March. Good luck!") });
          return;
        }

        localStorage.saveList(QUESTIONS_KEY, []);

        let surveyMessage = get(Auth.getLanguage(), 'local_locale') === 'fr' ? 'Kindly login to view the CDR' : 'Kindly login to view the CDR';
        let reviewMessage = get(Auth.getLanguage(), 'local_locale') === 'fr' ? "Merci de votre engagement envers l'excellence organisationnelle! Vous avez complété avec succès la deuxième phase de votre candidature pour les Prix d'excellence des OSC africaines." : 'Thank you for your commitment to organizational excellence! You have successfully completed stage II of the application for the African CSO Excellence Awards.';

        let currentStage = get(Auth.getUser(), 'current_stage_id');
        let previousStage = localStorage.getItem(PREVIOUS_STAGE_KEY);

        if (currentStage === previousStage) {
          Auth.saveFlashMessage(surveyMessage);
          Auth.logout();
        } else {
          Auth.saveFlashMessage(reviewMessage);
          Auth.logout();
        }


        if(this.state.questions) this.props.history.push("/section/5b7a91a6ff26");

        QuestionnaireSubject.next();
      })
      .catch(error => {
        this.setState({ errorMessage: "Problem transitioning you to the CDR." });
        SavingSubject.next({ saving: false });
      });
  };

  onSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((error) => {
      if (!error) {
        this.props.history.push(`/section/${this.props.nextSectionId}`);
      }
    });
  };

  processQuestion = (questionDef, index, parentLink = false) => {
    const questions = get(questionDef, 'questions');

    const baseQuestion = get(questionDef, 'question_type') === 'multiple_questions' ? (
      <div key={`${index}-${get(questionDef, this.props.titleKey)}`}>
        {parentLink ? (
          <Text modifiers="question-title primary-blue">
            {' '}
            {get(questionDef, this.props.titleKey)}
          </Text>
          ) : (
            <li className={`question-list__item__question ${get(questionDef, 'question_type')}`}>
              <Text>
                {' '}
                {get(questionDef, this.props.titleKey)}
                <span className="primary-orange">
                  {get(questionDef, 'is_mandatory') ? '*' : null}
                </span>
              </Text>
            </li>
          )}
        <ol className={`question-list ${get(questionDef, 'question_type')}`}>
          {questions.map((questionItem, qnIndex) => this.processQuestion(questionItem, qnIndex))}
        </ol>
      </div>
      ) : (
        <li
          className="question-list__item"
          key={`${index}-${get(questionDef, this.props.titleKey)}`}
        >
          <div className="question-list__item__question">
            <Text>
              {get(questionDef, this.props.titleKey)}
              <span className="primary-orange">
                {get(questionDef, 'is_mandatory') ? '*' : null}
              </span>
            </Text>
          </div>
          {questions && questions.length ? (
            questions.map((questionItem, qnIndex) => this.processQuestion(questionItem, qnIndex))
          ) : (
            <FieldProcessor
              titleKey={this.props.titleKey}
              valueKey={this.props.valueKey}
              responses={this.props.responses}
              question={questionDef}
              form={this.props.form}
              addRow={this.addRow}
              newRowValue={this.state.newRowValue}
            />
          )}
        </li>
      );

    return baseQuestion;
  };

  render() {
    const sectionQuestionnaire = Auth.getQuestions();

    let currentStage = get(Auth.getUser(), 'current_stage_id');
    let previousStage = localStorage.getItem(PREVIOUS_STAGE_KEY);

    const surveryStageExplanation = currentStage === previousStage ? (
      <div className="intro-banner">
        <Text type="explanation" modifiers="heavy primary-orange full-width">
          <FormattedMessage
            id="Welcome.Explanation"
            defaultMessage={`Welcome to the African CSO Excellence Awards application`}
          />
        </Text>
        <ul className="dashed-list">
          <li>
            <span>
              <FormattedMessage
                id="Welcome.Explanation.Point.1"
                defaultMessage="Please answer all questions. Doing so enables your organization to score higher in the selection process."
              />
            </span>
          </li>
          <li>
            <span>
              <FormattedMessage
                id="Welcome.Explanation.Point.2"
                defaultMessage="All the information you provide, including the documents submitted will be kept strictly confidential."
              />
            </span>
          </li>
          <li>
            <span>
              <FormattedMessage
                id="Welcome.Explanation.Point.4"
                defaultMessage="You can navigate in the questionnaire using the menu on the left, you can save your work and complete it at a later time"
              />
            </span>
          </li>
          <li>
            <span>
              <FormattedMessage id="Welcome.Explanation.Point.6" defaultMessage="Good Luck!" />
            </span>
          </li>
        </ul>
        <Link
          to={`/section/${get(sectionQuestionnaire[0], 'id', '')}`}
          className="btn btn-primary inline"
        >
          <Text type="small">
            <FormattedMessage
              id="Questionnaire.Start"
              defaultMessage="Start"
            />
          </Text>
        </Link>
      </div>
    ) : (
        <div className="intro-banner">
          <Text type="explanation" modifiers="heavy primary-orange full-width">
            <FormattedMessage
              id="Welcome.Explanation.Stage2"
              defaultMessage={`Welcome to Stage II of the African CSO Excellence Awards application`}
            />
          </Text>
          <ul className="dashed-list">
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.1"
                  defaultMessage="Please answer all questions. Doing so enables your organization to score higher in the selection process."
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Point.2"
                  defaultMessage="All the information you provide, including the documents submitted will be kept strictly confidential."
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage
                  id="Welcome.Explanation.Stage2.Point.4"
                  defaultMessage="You can navigate in the questionnaire using the menu on the left, you can save your work and complete it at a later time."
                />
              </span>
            </li>
            <li>
              <span>
                <FormattedMessage id="Welcome.Explanation.Point.6" defaultMessage="Good Luck!" />
              </span>
            </li>
          </ul>
          <Link
            to={`/section/${this.props.nextSectionId}`}
            className="btn btn-primary inline"
          >
            <Text type="small">
              <FormattedMessage
                id="Questionnaire.Start"
                defaultMessage="Start"
              />
            </Text>
          </Link>
        </div>
    );


    if (this.props.sectionIndex === -1 && this.state.surveyMode ) {
      return surveryStageExplanation;
    } else if (!this.state.surveyMode){
      let CdrComponent = get(find(CDRComponentMap, ['route', this.props.match.params.id]), 'component');

      if (!CdrComponent) {
        return <PageNotFound/>
      }

      const nextBtn = this.props.nextSectionId ? (
        <Button onClick={this.goToNextpage} nature="primary" type="button">
          <Text type="small">
            <FormattedMessage
              id="Questionnaire.Next"
              defaultMessage="Next"
            />
          </Text>
        </Button>
      ) : null;

      return (
        <div>
          <CdrComponent/>
          <div className="row cdr-next-btn">
            {nextBtn}
          </div>
        </div>
      );
    }

    const { saving, statusMessage } = this.state;

    let questionFields;

    if (this.props.sectionIndex !== -1) {
      questionFields = this.state.questions.map((questionDef, index) => this.processQuestion(questionDef, index, true));
    }

    return (
      <section>
        {saving ? (
          <Text type="small-semi-bold" modifiers="saving-indicator ">
            {statusMessage || 'Saving...'}
          </Text>
        ) : null}
        {
          this.state.errorMessage ? (
            <Text type="small" modifiers="mandatory-explanation alert">{this.state.errorMessage}</Text>
          ) : null
        }
        <form onSubmit={this.onSubmit} className="form">
          <ol className="question-list">{questionFields}</ol>
          <div className="action-bar clearfix">
            {this.props.nextSectionId ? (
              <div>
                <Button nature="primary" type="submit">
                  <Text type="small">
                    <FormattedMessage
                      id="Questionnaire.Proceed"
                      defaultMessage="Proceed"
                    />
                  </Text>
                </Button>
                <Button onClick={this.saveAndContinue} nature="default" type="button">
                  <Text type="small">
                    <FormattedMessage
                      id="Questionnaire.SaveAndComeBackLater"
                      defaultMessage="Save and come back later"
                    />
                  </Text>
                </Button>
              </div>
            ) : null}
            {!this.props.nextSectionId && sectionQuestionnaire.length ? (
              <Button nature="primary" onClick={this.completeApplication} type="button">
                <Text type="small">
                  <FormattedMessage
                    id="Questionnaire.CompleteApplication"
                    defaultMessage="Complete Application"
                  />
                </Text>
              </Button>
            ) : null}
          </div>
        </form>
      </section>
    );
  }
}

const WrappedForm = createForm({
  onValuesChange(_, changedValues, allValues) {
    SavingSubject.next({ saving: true });

    if (timeout) clearTimeout(timeout);

    const handleProcessing = () => {
      const formId = get(_, 'questions[0].form_id', '');

      const getKey = Object.keys(changedValues);

      const questionId = getKey[0];

      let currentValue; 
      
      switch (activeControlType) {
        case 'checkbox':
          currentValue = selectedFields;
          break;
        case 'radio':
          currentValue = selectedFields;
          break;  
        default:
          currentValue = get(allValues, questionId);
          break;
      }
      
      // reset the global control
      activeControlType = '';

      const response = get(_.responses, getKey);

      const multiInput = (response && Object.keys(response)) || [];

      if (response && response.splice && response.length > 1) {
        currentValue = map(currentValue, (valueProp, index) => {
          const rowKeys = Object.keys(currentValue[0]);

          const row = response[index] || {};

          const newValue = {};

          forEach(rowKeys, (key) => {
            newValue[key] = currentValue[index][key] || row[key];
          });

          return newValue;
        });
      }

      if (multiInput && multiInput.length && typeof response !== 'string') {
        const allKeys = Object.keys(currentValue);

        forEach(allKeys, (key) => {
          currentValue[key] = currentValue[key] || response[key];
        });
      }

      const stringifiedValue = JSON.stringify(currentValue);

      let payload = {
        form_id: formId,
        user_id: get(Auth.getUser(), 'id'),
        response: stringifiedValue,
      };

      if (fileItem) {
        const data = new FormData();

        data.append('response_file', get(fileItem, 'fileItem'));

        data.append('response', get(fileItem, 'fieldId'));

        data.append('form_id', formId);

        data.append('user_id', get(Auth.getUser(), 'id'));

        payload = data;

        fileItem = '';
      }

      axios
        .post(`/question/${questionId}/response`, payload)
        .then(() => {
          SavingSubject.next({ saving: false });
        })
        .catch((error) => {
          SavingSubject.next({
            saving: true,
            statusMessage: get(error, 'response.data.message') || error,
          });
        });
    };

    processQue.push(handleProcessing);

    timeout = setTimeout(() => {
      processQue[processQue.length - 1]();
      processQue = [];
    }, 600);
  }
})(FormLayout);

export default WrappedForm;



// WEBPACK FOOTER //
// ./src/components/BaseQuestionnaire/FormLayout.js